import { useRouter } from 'next/router'
import { useEffect } from 'react'

const saveScroll = () => {
	const scrollPosition = document.scrollingElement?.scrollTop.toString() ?? '0'
	localStorage.setItem('scrollPosition', scrollPosition)
}

export const useRememberScrollPosition = () => {
	const router = useRouter()

	useEffect(() => {
		if (document.scrollingElement) {
			const scrollPosition = Number(localStorage.getItem('scrollPosition')) || 0
			document.scrollingElement.scrollTop = scrollPosition
		}

		router.events.on('routeChangeStart', saveScroll)
		return () => router.events.off('routeChangeStart', saveScroll)
	}, [])
}
